import useApi from '../../../hooks/use-api';
import { get } from 'lodash';
import { iseCurrentStudent } from '../../../utilities/is-current-student';
import getUserFullName from '../../../utilities/get-user-full-name';
import useCourseEnroll from './use-course-enroll';

export const useStudentSelector = ({
    courseId
} = {}) => {
    const { api, url, endpoints } = useApi();
    const { enroll, isLoading } = useCourseEnroll({ courseId });
    const retrieveStudents = async (search) => {
        const filters = {
            r: 's',
            offset: 0,
            limit: 10,
            s: search,
        };
        const response = await api.get(url(endpoints.users, {}, filters));
        const students = get(response, 'items', [])
            .filter(iseCurrentStudent);
        return students.map(student => ({
            value: student.id,
            label: getUserFullName(student, { grade: true })
        }))
    };

    const onChange = (student) => {
        if (student) {
            enroll({ id: student.value });
        }
    }

    return {
        retrieveStudents,
        onChange,
        isLoading
    }
};
